/* eslint-disable max-len */
import { ICONS_ID } from '@bitComponents/unifiedIcons/SvgIconLoader';
import { CHARACTERISTICS, CHARACTERISTIC_VALUES, CQ_ACTION_CODES, CQ_POTS } from '../../catalogConstants';
import { USER_TYPE } from '../../bitConstants/constants';
import { SHOPPING_CART_CONSTANTS } from '../../bitComponents/ShoppingCart/textConstants';
import { PAYMENT_TYPES } from '../../utils/payment';
import { PRODUCT_TYPES } from '../../utils/catalog';
import { WEBSERVICE_ERRORS } from '../../errorManagement/errorCatalog';
import { URLS } from '../../errorManagement/errorToPrint/errorTextsConstants';

export const STRING_KEYS = {
  process: {
    title: 'processTitle',
  },
  shipment: {
    send: 'shipmentSendText',
    disclaimer: 'shipmentDisclaimer',
    text: 'shipmentText',
    secondaryText: 'shipmentSecondaryText',
    prePurchaseText: 'shipmentPrePurchaseText',
    prePurchaseSecondaryText: 'shipmentPrePurchaseSecondaryText',
    new: 'shipmentNewShipmentText',
    iconId: 'shipmentIconId',
  },
  installation: {
    text: 'installationText',
    iconId: 'installationIconId',
    new: 'installationNew',
  },
  permanentResidence: {
    residence: 'permanentResidence',
    shipmentAsResidence: 'permanentResidenceShipmentAsResidence',
  },
  payment: {
    step: {
      insertDirectDebit: 'paymentStepInsertDirectDebit',
      insertDirectDebitSecondaryText: 'paymentStepInsertDirectDebitSecondaryText',
      chooseDirectDebit: 'paymentStepChooseDirectDebit',
      chooseDirectDebitSecondaryText: 'paymentStepChooseDirectDebitSecondaryText',
      icon: 'paymentStepIcon',
      inputTitle: 'paymentStepInputTitle',
      newAccText: 'paymentStepNewAccText',
    },
  },
  advertisingUse: {
    check: 'advertisingUseCheck',
  },
  shoppingCart: {
    taxesBand: 'shoppingCartTaxesBand',
    specificTaxesBand: 'shoppingCartSpecificTaxesBand',
    title: 'shoppingCartTitle',
    prePurchaseTitle: 'shoppingCartPrePurchaseTitle',
    haveMaintainingPromo: 'shoppingCartHaveMaintainingPromo',
    downgradeAdviceTitle: 'shoppingCartDowngradeAdviceTitle',
    downgradeAdviceText: 'shoppingCartDowngradeAdviceText',
    characteristic: {
      [CHARACTERISTICS.NETFLIX]: {
        [CHARACTERISTIC_VALUES.NETFLIX.STANDARD]: 'shoppingCartCharacteristicNetflixStandard',
        [CHARACTERISTIC_VALUES.NETFLIX.STANDARD_ADS]: 'shoppingCartCharacteristicNetflixStandardAds',
        [CHARACTERISTIC_VALUES.NETFLIX.PREMIUM]: 'shoppingCartCharacteristicNetflixPremium',
      },
    }
  },
  selectParentProduct: {
    subtitle: 'selectParentProductSubtitle',
    label: 'selectParentProductLabel',
  },
  summary: {
    title: 'summaryTitle',
    actionTitle: {
      [CHARACTERISTIC_VALUES.SPEED['300MB']]: 'summaryActionTitle300MB',
      [CHARACTERISTIC_VALUES.SPEED['600MB']]: 'summaryActionTitle600MB',
      [CHARACTERISTIC_VALUES.SPEED['1GB']]: 'summaryActionTitle1GB',
      [CHARACTERISTIC_VALUES.SPEED['2GB']]: 'summaryActionTitle2GB',
      [CHARACTERISTIC_VALUES.SPEED['10GB']]: 'summaryActionTitle10GB',
    },
    oneClick: {
      title: 'summaryOneClickTitle',
      actionMsg: {
        default: 'summaryOneClickActionMsgDefault',
        [CHARACTERISTIC_VALUES.SPEED['300MB']]: 'summaryOneClickActionMsg300MB',
        [CHARACTERISTIC_VALUES.SPEED['600MB']]: 'summaryOneClickActionMsg600MB',
        [CHARACTERISTIC_VALUES.SPEED['1GB']]: 'summaryOneClickActionMsg1GB',
        [CHARACTERISTIC_VALUES.SPEED['2GB']]: 'summaryOneClickActionMsg2GB',
        [CHARACTERISTIC_VALUES.SPEED['10GB']]: 'summaryOneClickActionMsg10GB',
      },
      mainMsg: 'summaryOneClickMainMsg',
    },
    mandatoryFieldsModal: {
      title: 'mandatoryModalTitle',
      subTitle: 'mandatoryModalSubtitle',
    },
    priceDiscrepancyModal: {
      title: 'discrepancyModalTitle',
      content: 'discrepancyModalContent',
      secondaryContent: 'discrepancyModalSecondaryContent',
      viewPriceButton: 'discrepancyModalViewPriceButton',
    },
    personalData: {
      title: 'summaryPersonalDataTitle',
    },
    productBarInfo: {
      icon: 'productBarInfoIcon',
      text: 'productBarInfoText',
      secondaryText: {
        [CQ_ACTION_CODES.REGISTER]: 'productBarInfoSecondaryTextRegister',
        [CQ_ACTION_CODES.PORTABILITY]: 'productBarInfoSecondaryTextPortability',
        [CQ_ACTION_CODES.MIGRATION]: 'productBarInfoSecondaryTextMigration',
        [CQ_ACTION_CODES.KEEP]: 'productBarInfoSecondaryTextKeep',
      },
      additionalInfoText: 'productBarInfoAdditionalInfoAdditionalInfoText',
    },
    mainActionSelected: {
      title: 'summaryMainActionSelectedTitle',
      value: 'summaryMainActionSelectedValue',
    },
    secondaryAction: {
      [CQ_ACTION_CODES.REGISTER]: 'summarySecondaryActionRegister',
      [CQ_ACTION_CODES.PORTABILITY]: 'summarySecondaryActionPortability',
      [CQ_ACTION_CODES.MIGRATION]: 'summarySecondaryActionMigration',
    },
    mobileLineAction: {
      title: 'summaryMobileLineActionTitle',
      multipleActionsTitle: 'summaryMobileLineActionMultipleActionsTitle',
      [CQ_ACTION_CODES.REGISTER]: 'summaryMobileLineActionRegister',
      [CQ_ACTION_CODES.PORTABILITY]: 'summaryMobileLineActionPortability',
      [CQ_ACTION_CODES.MIGRATION]: 'summaryMobileLineActionMigration',
      [CQ_ACTION_CODES.KEEP]: 'summaryMobileLineActionKeep',
      [CQ_ACTION_CODES.NO_ACTION]: 'summaryMobileLineActionNoAction',
      [CQ_ACTION_CODES.UNSUBSCRIBE]: 'summaryMobileLineActionUnsubscribe',
      icon: 'summaryMobileLineActionIcon',
      index: 'summaryMobileLineActionIndex',
      alreadyOwnedProductsChoices: {
        title: 'summaryMobileLineActionAlreadyOwnedProductsChoicesTitle',
        [CQ_ACTION_CODES.UNSUBSCRIBE]: 'summaryMobileLineActionAlreadyOwnedProductsChoicesUnsubscribe',
        [CQ_ACTION_CODES.MIGRATION]: 'summaryMobileLineActionAlreadyOwnedProductsChoicesMigration',
      },
    },
    additionalMobileLineAction: {
      title: 'summaryAdditionalMobileLineActionTitle',
    },
    packMobileLineAction: {
      title: 'summaryPackMobileLineActionTitle',
    },
    landLineAction: {
      title: 'summaryLandLineActionTitle',
      [CQ_ACTION_CODES.REGISTER]: 'summaryLandLineActionRegister',
      [CQ_ACTION_CODES.PORTABILITY]: 'summaryLandLineActionPortability',
      [CQ_ACTION_CODES.MIGRATION]: 'summaryLandLineActionMigration',
      portabilityWithPPIP: 'summaryLandLineActionPortabilityWithPPIP',
      [CQ_ACTION_CODES.KEEP]: 'summaryLandLineActionKeep',
      icon: 'summaryLandLineActionIcon',
      label: {
        [CQ_ACTION_CODES.REGISTER]: 'summaryLandLineActionLabelRegister',
        [CQ_ACTION_CODES.PORTABILITY]: 'summaryLandLineActionLabelPortability',
        [CQ_ACTION_CODES.MIGRATION]: 'summaryLandLineActionLabelMigration',
        portabilityWithPPIP: 'summaryLandLineActionLabelPortabilityWithPPIP',
        [CQ_ACTION_CODES.KEEP]: 'summaryLandLineActionLabelKeep',
      },
      subtitle: {
        [CQ_ACTION_CODES.REGISTER]: 'summaryLandLineActionSubtitleRegister',
        [CQ_ACTION_CODES.PORTABILITY]: 'summaryLandLineActionSubtitlePortability',
        [CQ_ACTION_CODES.MIGRATION]: 'summaryLandLineActionSubtitleMigration',
        portabilityWithPPIP: 'summaryLandLineActionSubtitlePortabilityWithPPIP',
        [CQ_ACTION_CODES.KEEP]: 'summaryLandLineActionSubtitleKeep',
      },
      technologyMigrationText: {
        [CQ_ACTION_CODES.REGISTER]: 'summaryLandLineActionTechnologyMigrationTextRegister',
        [CQ_ACTION_CODES.PORTABILITY]: 'summaryLandLineActionTechnologyMigrationTextPortability',
        [CQ_ACTION_CODES.MIGRATION]: 'summaryLandLineActionTechnologyMigrationTextMigration',
        portabilityWithPPIP: 'summaryLandLineActionTechnologyMigrationTextPortabilityWithPPIP',
        [CQ_ACTION_CODES.KEEP]: 'summaryLandLineActionTechnologyMigrationTextKeep',
      },
    },
    afterSaleParentProductSelected: {
      title: 'afterSaleParentProductSelectedTitle',
      phoneNumberLabel: 'afterSaleParentProductSelectedPhoneNumberLabel',
      adviceIcon: 'afterSaleParentProductSelectedAdviceIcon',
      advice: 'afterSaleParentProductSelectedAdvice',
    },
    selectLine: {
      title: 'selectLineTitle',
    },
    typeOfSim: {
      title: 'summaryTypeOfSimTitle',
    },
    shipment: {
      title: 'summaryShipmentTitle',
      secondaryText: 'summaryShipmentSecondaryText',
      prePurchaseSecondaryText: 'summaryShipmentPrePurchaseSecondaryText',
      text: 'summaryShipmentText',
      prePurchaseText: 'summaryShipmentPrePurchaseText',
    },
    storeShipping:{
      title: 'summaryStoreShippingTitle',
      text: 'summaryStoreShippingText',
      secondaryText: 'summaryStoreShippingSecondaryText',
      adviceText: 'summaryStoreShippingAdviceText',
    },
    webAppShipping:{
      title: 'summaryWebAppShippingTitle',
      text: 'summaryWebAppShippingText',
      secondaryText: 'summaryWebAppShippingSecondaryText',
    },
    cashOnDelivery:{
      title: 'summaryCashOnDeliveryTitle',
      text: 'summaryCashOnDeliveryText',
      secondaryText: 'summaryCashOnDeliverySecondaryText',
    },
    prepaidActivation:{
      title: 'summaryPrepaidActivationTitle',
      text: 'summaryPrepaidActivationText',
      secondaryText: 'summaryPrepaidActivationSecondaryText',
    },
    installation: {
      title: 'summaryInstallationTitle',
      advice: {
      text: {
        [CQ_POTS.INSTALLATION_POT.INSTALLATION_ID]: 'summaryInstallationAdviceWithInstallationText',
        [CQ_POTS.INSTALLATION_POT.AUTO_INSTALLATION_ID]: 'summaryInstallationAdviceWithAutoInstallationText',
        [CQ_POTS.INSTALLATION_POT.INSTALLATION_BY_CLIENT]: 'summaryInstallationAdviceWithInstallationByClientText',
      }
    }
    },
    yomvi: {
      title: 'summaryYomviTitle',
      text: 'summaryYomviText',
      secondaryText: 'summaryYomviSecondaryText',
    },
    staticDirectDebit: 'staticDirectDebit',
    paymentCard: {
      title: 'summaryPayment',
      paymentRadioItem: {
        fundedPayment: {
          label: 'fundedPaymentLabel',
          children: {
            subtitle: 'fundedPaymentSubtitle',
            box: {
              line1: 'fundedPaymentLine1',
              price: 'fundedPaymentPrice',
              totalTaxes: 'fundedPaymentTotalTaxes',
              totalAmount: 'totalAmount',
              lastMonthlyPayment: 'fundedPaymentlastMonthlyPayment',
            },
            p1: 'fundedPaymentP1',
            p2: 'fundedPaymentP2',
          },
        },
        cardPayment: {
          label: 'cardPaymentLabel',
          children: {
            description: 'cardPaymentDescription',
          },
        },
      },
    },
    mobileInsurance: {
      title: 'mobileInsuranceTitle',
      infoBar: 'mobileInsuranceInfoBar',
      claimText: 'mobileInsuranceClaimText',
    },
    nextSteps: 'summaryNextSteps',
    shoppingCart: {
      title: 'summaryShoppingCartTitle',
    },
    activationCard: {
      image: 'summaryActivationCardImage',
      title: 'summaryActivationCardTitle',
      description: 'summaryActivationCardDescription',
    },
    nonFiberCoverage: {
      title: 'summaryNonFiberCoverageTitle',
      subtitle: 'summaryNonFiberCoverageSubtitle',
    },
    manualSummaryAdvice: {
      text: 'manualSummaryAdviceText',
      linkText: 'manualSummaryAdviceLinkText',
      link: 'manualSummaryAdviceLink'
    },
    cart: {
      alwaysNew: 'summaryCartAlwaysNew',
      alwaysNewTemplate: 'summaryCartAlwaysNewTemplate',
      oneTimeChargesTitle: {
        [CQ_POTS.PAYMENT_POT.DIRECT_DEBIT_ID]: 'oneTimeChargesTitleDirectDebit',
        [CQ_POTS.PAYMENT_POT.CARD]: 'oneTimeChargesTitleCard',
        [CQ_POTS.PAYMENT_POT.FUNDED]: 'oneTimeChargesTitleFunded',
        [CQ_POTS.PAYMENT_POT.FUNDED_NO_TAXES]: 'oneTimeChargesTitleFundedNoTaxes',
        [CQ_POTS.PAYMENT_POT.FUNDED_SPECIAL_TAXES]: 'oneTimeChargesTitleFundedSpecialTaxes',
      },
      manualOneTimeChargesTitle: 'manualOneTimeChargesTitle',
      oneTimeChargesFinalPriceText: {
        [CQ_POTS.PAYMENT_POT.DIRECT_DEBIT_ID]: 'oneTimeChargesFinalPriceTextDirectDebit',
        [CQ_POTS.PAYMENT_POT.CARD]: 'oneTimeChargesFinalPriceTextCard',
        [CQ_POTS.PAYMENT_POT.FUNDED]: 'oneTimeChargesFinalPriceTextFunded',
        [CQ_POTS.PAYMENT_POT.FUNDED_NO_TAXES]: 'oneTimeChargesFinalPriceTextFundedNoTaxes',
        [CQ_POTS.PAYMENT_POT.FUNDED_SPECIAL_TAXES]: 'oneTimeChargesFinalPriceTextFundedSpecialTaxes',
      },
      manualOneTimeChargesFinalPriceText: 'manualOneTimeChargesFinalPriceText',
      recurringChargesFinalPriceText: {
        [CQ_POTS.PAYMENT_POT.DIRECT_DEBIT_ID]: 'recurringChargesFinalPriceTextDirectDebit',
        [CQ_POTS.PAYMENT_POT.CARD]: 'recurringChargesFinalPriceTextCard',
        [CQ_POTS.PAYMENT_POT.FUNDED]: 'recurringChargesFinalPriceTextFunded',
        [CQ_POTS.PAYMENT_POT.FUNDED_NO_TAXES]: 'recurringChargesFinalPriceTextFundedNoTaxes',
        [CQ_POTS.PAYMENT_POT.FUNDED_SPECIAL_TAXES]: 'recurringChargesFinalPriceTextFundedSpecialTaxes',
      },
      manualRecurringChargesFinalPriceText: 'manualRecurringChargesFinalPriceText',
      recurringChargesFinalPriceTextBelow: {
        [CQ_POTS.PAYMENT_POT.DIRECT_DEBIT_ID]: 'recurringChargesFinalPriceTextBelowDirectDebit',
        [CQ_POTS.PAYMENT_POT.CARD]: 'recurringChargesFinalPriceTextBelowCard',
        [CQ_POTS.PAYMENT_POT.FUNDED]: 'recurringChargesFinalPriceTextBelowFunded',
        [CQ_POTS.PAYMENT_POT.FUNDED_NO_TAXES]: 'recurringChargesFinalPriceTextBelowFundedNoTaxes',
        [CQ_POTS.PAYMENT_POT.FUNDED_SPECIAL_TAXES]: 'recurringChargesFinalPriceTextBelowFundedSpecialTaxes',
      },
      manualRecurringChargesFinalPriceTextBelow: 'manualRecurringChargesFinalPriceTextBelow',
      oneTimeChargesFinalPriceTextBelow: {
        [CQ_POTS.PAYMENT_POT.DIRECT_DEBIT_ID]: 'oneTimeChargesFinalPriceTextBelowDirectDebit',
        [CQ_POTS.PAYMENT_POT.CARD]: 'oneTimeChargesFinalPriceTextBelowCard',
        [CQ_POTS.PAYMENT_POT.FUNDED]: 'oneTimeChargesFinalPriceTextBelowFunded',
        [CQ_POTS.PAYMENT_POT.FUNDED_NO_TAXES]: 'oneTimeChargesFinalPriceTextBelowFundedNoTaxes',
        [CQ_POTS.PAYMENT_POT.FUNDED_SPECIAL_TAXES]: 'oneTimeChargesFinalPriceTextBelowFundedSpecialTaxes',
      },
      manualOneTimeChargesFinalPriceTextBelow: 'manualOneTimeChargesFinalPriceTextBelow',
      mobileInsuranceTitle: 'mobileInsuranceTitle',
      pocDuration: 'pocDuration',
    },
    productOfferingToBuyChangedModal: {
      title: 'ProductOfferingToBuyChangedModalTitle',
      text: 'ProductOfferingToBuyChangedModalText',
      button: 'ProductOfferingToBuyChangedModalButton',
    },
  },
  registerPersonalData:{
    usePassportButtonLabel: 'registerPersonalDataUsePassportButtonLabel',
    useDNIButtonLabel: 'registerPersonalDataUseDNIButtonLabel',
    inputs: {
      nameLabel: 'registerPersonalDataInputsNameLabel',
      firstSurnameLabel: 'registerPersonalDataInputsFirstSurnameLabel',
      secondSurnameLabel: 'registerPersonalDataInputsSecondSurnameLabel',
      nationalityLabel: 'registerPersonalDataInputsNationalityLabel',
      documentNumberDNILabel: 'registerPersonalDataInputsDocumentNumberDNILabel',
      documentNumberPassportLabel: 'registerPersonalDataInputsDocumentNumberPassportLabel',
      contactPhoneLabel: 'registerPersonalDataInputsContactPhoneLabel',
      contactPhoneLabelDescription: 'registerPersonalDataInputsContactPhoneLabelDescription',
      emailLabel: 'registerPersonalDataInputsEmailLabel',
    },
    otpModal: {
      title: 'registerPersonalDataOtpModalTitle',
      requestedTextSms: 'registerPersonalDataOtpModalRequestedTextSms',
      pinError: 'registerPersonalDataOtpModalPinError',
      pinExpired: 'registerPersonalDataOtpModalPinExpired',
      validateButton: 'registerPersonalDataOtpModalValidateButton',
      newCodeButton: 'registerPersonalDataOtpModalNewCodeButton',
    }
  },
  cardPayment: {
    title: 'cardPaymentTitle',
    infoBar: 'cardPaymentPaymentInfoBar',
    infoBarIcon: 'cardPaymentPaymentInfoBarIcon',
    visaImg: 'cardPaymentVisaImg',
    masterCardImg: 'cardPaymentMasterCardImg',
  },
  mainAction: {
    [`${CQ_ACTION_CODES.REGISTER}`]: 'mainActionRegister',
    [`${CQ_ACTION_CODES.PORTABILITY}`]: 'mainActionPortability',
    [`${CQ_ACTION_CODES.MIGRATION}`]: {
      multiplePhoneNumbers: 'multiplePhoneNumbers',
      uniquePhoneNumber: 'uniquePhoneNumber',
    },
    [`${CQ_ACTION_CODES.KEEP}`]: 'mainActionKeep',
    migrationSelectionTitle: 'mainActionSelectionTitle',
    infoBar: {
      icon: 'mainActionInfoBarIcon',
      label: 'mainActionInfoBarLabel',
    },
    subTitle: 'mainActionSubTitle',
  },
  mobileSecondaryAction: {
    lmaStepAvice: {
      title: 'mobileSecondaryActionLmaStepAdviceTitle',
      steps: 'mobileSecondaryActionLmaStepAdviceSteps',
    },
    [`${CQ_ACTION_CODES.REGISTER}`]: 'mobileSecondaryActionRegister',
    [`${CQ_ACTION_CODES.PORTABILITY}`]: 'mobileSecondaryActionPortability',
    [`${CQ_ACTION_CODES.NO_ACTION}`]: 'mobileSecondaryActionNoAction',
    [`${CQ_ACTION_CODES.MIGRATION}`]: {
      multiplePhoneNumbers: 'mobileSecondaryMultiplePhoneNumbers',
      uniquePhoneNumber: 'mobileSecondaryUniquePhoneNumber',
    },
    [`${CQ_ACTION_CODES.KEEP}`]: 'mobileSecondaryActionKeep',
    migrationSelectionTitle: 'mobileSecondaryActionMigrationSelectionTitle',
    migrationNKeepSelectPlaceholder: 'mobileSecondaryActionMigrationNKeepSelectPlaceholder',
    infoBar: {
      index: 'mobileSecondaryActionInfoBarIndex',
      icon: 'mobileSecondaryActionInfoBarIcon',
      label: 'mobileSecondaryActionInfoBarLabel',
    },
    subTitle: 'mobileSecondaryActionSubTitle',
    newLines: 'mobileSecondaryActionNewLines',
    oldLines: 'mobileSecondaryActionOldLines',
  },
  landLineSecondaryAction: {
    [`${CQ_ACTION_CODES.REGISTER}`]: 'landLineSecondaryActionRegister',
    [`${CQ_ACTION_CODES.PORTABILITY}`]: 'landLineSecondaryActionPortability',
    [`${CQ_ACTION_CODES.MIGRATION}`]: {
      multiplePhoneNumbers: 'landLineSecondaryMultiplePhoneNumbers',
      uniquePhoneNumber: 'landLineSecondaryUniquePhoneNumber',
    },
    [`${CQ_ACTION_CODES.KEEP}`]: 'landLineSecondaryActionKeep',
    migrationSelectionTitle: 'landLineSecondaryActionSelectionTitle',
    infoBar: {
      icon: 'landLineSecondaryActionInfoBarIcon',
      label: 'landLineSecondaryActionInfoBarLabel',
    },
    subTitle: 'landLineSecondaryActionSubTitle',
  },
  mobilePortability: {
    phoneNumberInputLabel: 'mobilePortabilityPhoneNumberInputLabel',
    phoneNumberInputDescription: 'mobilePortabilityPhoneNumberInputDescription',
    smsAdvice: 'mobilePortabilityPhoneSmsAdvice',
    prepaidCheckLabel: 'mobilePortabilityPhonePrepaidCheckLabel',
    getPinButton: 'mobilePortabilityPhoneGetPinButton',
    getNewPinButton: 'mobilePortabilityPhoneGetNewPinButton',
    validatePinButton: 'mobilePortabilityPhoneValidatePinButton',
    iccInputPlaceHolder: 'mobilePortabilityPhoneIccInputPlaceHolder',
    iccHelp: 'mobilePortabilityPhoneIccHelp',
    iccHelpModalTitle: 'mobilePortabilityPhoneIccHelpModalTitle',
    iccHelpModalImg: 'mobilePortabilityPhoneIccHelpModalImg',
    iccHelpModalFirstText: 'mobilePortabilityPhoneIccHelpModalFirstText',
    iccHelpModalSecondText: 'mobilePortabilityPhoneIccHelpModalSecondText',
    phoneNumberInputRequired: 'mobilePortabilityPhonePhoneNumberInputRequired',
    pinValidationInput: 'mobilePortabilityPhonePinValidationInput',
    pinValidationError: 'mobilePortabilityPhonePinValidationError',
    pinValidationMaxRetriesError: 'mobilePortabilityPhonePinValidationMaxRetriesError',
    changePhoneNumber: 'mobilePortabilityPhoneChangePhoneNumber',
    componentValidationKO: 'mobilePortabilityPhoneComponentValidationKO',
    errorModalTitle: 'mobilePortabilityPhoneErrorModalTitle',
    errorModalButton: 'mobilePortabilityPhoneErrorModalButton',
    validationModal: {
      requestedTextSms: 'mobilePortabilityPhoneValidationModalRequestedTextSms',
      title: 'mobilePortabilityPhoneValidationModalTitle',
      pinError: 'mobilePortabilityPhoneValidationModalPinError',
      maxRetriesError: 'mobilePortabilityPhoneValidationModalMaxRetriesError',
      validateButton: 'mobilePortabilityPhoneValidationModalValidateButton',
      newCodeButton: 'mobilePortabilityPhoneValidationModalNewCodeButton',
    },
  },
  alreadyOwnedProductsChoices: {
    obligateChoicesTitle: 'alreadyOwnedProductsChoicesObligateChoicesTitle',
    obligateChoicesLine: 'alreadyOwnedProductsChoicesObligateChoicesLine',
    [`${CQ_ACTION_CODES.UNSUBSCRIBE}`]: 'alreadyOwnedProductsChoicesObligateChoicesUnsubscribe',
    [`${CQ_ACTION_CODES.MIGRATION}`]: 'alreadyOwnedProductsChoicesObligateChoicesMigration',
    migrationLonely: 'alreadyOwnedProductsChoicesMigrationLonely',
    selectTitle: 'alreadyOwnedProductsChoicesSelectTitle',
  },
  afterSaleParentProductInfoBar: {
    icon: 'afterSaleParentProductInfoBarIcon',
    text: {
      [CQ_POTS.INSTALLATION_POT.INSTALLATION_ID]: 'afterSaleParentProductInfoBarInstallationText',
      [CQ_POTS.INSTALLATION_POT.AUTO_INSTALLATION_ID]: 'afterSaleParentProductInfoBarAutoInstallationText',
    },
  },
  selectLine: {
    text: 'selectLineText',
    selectLabel: 'selectLineSelectLabel',
  },
  multiSimOptions: {
    numberOfSims: {
      text: 'multiSimOptionsNumberOfSimsText',
      selectLabel: 'multiSimOptionsNumberOfSimsSelectLabel',
    },
    typeOfSims: {
      text: 'multiSimOptionsTypeOfSimsText',
    },
  },
  stepTitles: {
    obdError: 'stepTitleObdError',
    obdResidenceError: 'stepTitleObdResidenceError',
    personalData: 'stepTitlePersonalData',
    productOfferingToBuyChanged: {
      [WEBSERVICE_ERRORS.INCOMPATIBLE_PRODUCT_CONTRATO_L]: 'stepTitleProductOfferingToBuyChangedIncompatibleProductContract',
      [WEBSERVICE_ERRORS.PRODUCT_WITHOUT_AVAILABLE_ACTIONS]: 'stepTitleProductOfferingToBuyChangedProductWithoutAvailableActions'
    },
    permanentResidence: 'stepTitlePermanentResidence',
    installation: 'stepTitleInstallation',
    newInstallationAddress: 'stepTitleNewInstallationAddress',
    selectParentProduct: 'stepSelectParentProduct',
    mainAction: 'stepTitleMainAction',
    mobileSecondaryAction: 'stepTitleMobileSecondaryAction',
    landLineSecondaryAction: 'stepTitleLandLineSecondaryAction',
    alreadyOwnedProductsChoices: 'stepTitleAlreadyOwnedProductsChoices',
    portabilityOTP: 'stepTitlePortabilityOTP',
    commitment: 'stepTitleCommitment',
    ppip: 'stepTitlePpip',
    deviceInstallation: 'stepTitleDeviceInstallation',
    shipment: 'stepTitleShipment',
    payment: 'stepTitlePayment',
    scoring: 'stepTitleScoring',
    chooseNumberOTP: 'stepTitleChooseNumberOTP',
    afterSaleParentProductSelector: 'afterSaleParentProductSelector',
    creditLimitError: 'stepTitleCreditLimitError',
    riskError: 'stepTitleRiskError',
    debtError: 'stepTitleDebtError',
    numberOfSims: 'stepTitlenumberOfSims',
  },
  productOfferingToBuyChanged: {
    [WEBSERVICE_ERRORS.INCOMPATIBLE_PRODUCT_CONTRATO_L]: {
      text: 'productOfferingToBuyChangedIncompatibleProductContractParagraph',
      secondaryText: 'productOfferingToBuyChangedIncompatibleProductContractSecondaryText',
      button: 'productOfferingToBuyChangedIncompatibleProductContractButton',
      oldProduct: 'productOfferingToBuyChangedIncompatibleProductContractOldProduct',
      newProduct: 'productOfferingToBuyChangedIncompatibleProductContractNewProduct',
      linkText: 'productOfferingToBuyChangedIncompatibleProductContractLinkText',
      url: 'productOfferingToBuyChangedIncompatibleProductContractUrl',
    },
    [WEBSERVICE_ERRORS.PRODUCT_WITHOUT_AVAILABLE_ACTIONS]: {
      text: 'productOfferingToBuyChangedProductWithoutAvailableActionsParagraph',
      secondaryText: 'productOfferingToBuyChangedProductWithoutAvailableActionsSecondaryText',
      button: 'productOfferingToBuyChangedProductWithoutAvailableActionsButton',
      oldProduct: 'productOfferingToBuyChangedProductWithoutAvailableActionsOldProduct',
      newProduct: 'productOfferingToBuyChangedProductWithoutAvailableActionsNewProduct',
      linkText: 'productOfferingToBuyChangedProductWithoutAvailableActionsLinkText',
      url: 'productOfferingToBuyChangedProductWithoutAvailableActionsUrl',
    },
  },
  risk: {
    title: 'riskTitle',
    firstParagraph: 'riskFirstParagraph',
    secondParagraph: 'riskSecondParagraph',
    personalData: 'riskPersonalData',
    button: 'riskButton',
    secondaryButton: 'secondaryRiskButton',
    modal: {
      buttonLink: 'riskModalButtonLink',
      buttonText: 'riskModalButtonText',
      title: 'riskModalTitle',
      paragraph: 'riskModalParagraph',
    },
  },
  se: {
    message:{
      error:{
        title: 'seMessageErrorTitle',
        description: 'seMessageErrorDescription'
      },
      shipping:{
        type:'seMessageShippingType',
        address:'seMessageShippingAddress',
        [`${CQ_POTS.SHIPPING_POT.HOME_SHIPPING_ID}`]: 'seMessageShippingTypeHome',
        [`${CQ_POTS.SHIPPING_POT.STORE_SHIPPING_ID}`]: 'seMessageShippingTypeStore',
      },
      installation:{
        [`${CQ_POTS.INSTALLATION_POT.INSTALLATION_ID}`]: 'seMessageInstallationTypeInstaller',
        [`${CQ_POTS.INSTALLATION_POT.AUTO_INSTALLATION_ID}`]: 'seMessageInstallationTypeAutoInstallation',
        [`${CQ_POTS.INSTALLATION_POT.INSTALLATION_BY_CLIENT}`]: 'seMessageInstallationTypeInstallationByClient',
      },
      payment:{
        account: 'seMessagePaymentAccount',
        customerAccountId: 'seMessagePaymentCustomerAccountId',
        sameAccount: 'seMessagePaymentSameAccount',
      },
      shoppingCart: {
        title: 'seMessageShoppingCartTitle',
        [`${PRODUCT_TYPES.INCLUDED_R2R}`]: `seMessageShoppingCartItemType_${PRODUCT_TYPES.INCLUDED_R2R}`,
        [`${PRODUCT_TYPES.ADDITIONAL_R2R}`]: `seMessageShoppingCartItemType_${PRODUCT_TYPES.ADDITIONAL_R2R}`,
        [`${PRODUCT_TYPES.ADDITIONAL_MOBILE}`]: `seMessageShoppingCartItemType_${PRODUCT_TYPES.ADDITIONAL_MOBILE}`,
        [`${PRODUCT_TYPES.TV}`]: `seMessageShoppingCartItemType_${PRODUCT_TYPES.TV}`,
        [`${PRODUCT_TYPES.NETFLIX}`]: `seMessageShoppingCartItemType_${PRODUCT_TYPES.NETFLIX}`,
      },
      speed: {
        title: 'seMessageSpeedTitle',
        [CHARACTERISTIC_VALUES.SPEED['300MB']]: 'seMessageSpeed300MB',
        [CHARACTERISTIC_VALUES.SPEED['600MB']]: 'seMessageSpeed600MB',
        [CHARACTERISTIC_VALUES.SPEED['1GB']]: 'seMessageSpeed1GB',
        [CHARACTERISTIC_VALUES.SPEED['2GB']]: 'seMessageSpeed2GB',
        [CHARACTERISTIC_VALUES.SPEED['10GB']]: 'seMessageSpeed10GB',
      }
    },
    risk: {
      subject: 'seRiskSubject',
    },
    order: {
      subject: 'seOrderSubject',
    },
    impersonationRisk: {
      idPOMessage: 'impersonationRiskIdPOMMessage',
    },
    shippingMobileInsurance: {
      subject: 'mobileInsuranceSubject',
    },
  },
  genesys: {
    campaign: 'genesysCampaign',
    riskCampaign: 'genesysRiskCampaign',
  },
  campaignCode: 'layerCampaignCode',
  clientRegister: {
    url: 'clientRegisterUrl',
  },
  legalNSubmit: {
    titleModal: 'legalNSubmitTitleModal',
    dataTransferTitle: 'legalNSubmitDataTransferTitle',
    dataTransferText: 'legalNSubmitDataTransferText',
    legalCheckout: {
      nonLinkableText: 'legalNSubmitLegalCheckoutNonLinkableText',
      linkableText: 'legalNSubmitLegalCheckoutLinkableText',
    },
    legalCancelR2R: {
      nonLinkableText: 'legalNSubmitLegalCancelR2RNonLinkableText',
      linkableText: 'legalNSubmitLegalCancelR2RLinkableText',
    },
    buttonText: 'legalNSubmitButtonText',
    buttonR2RText: 'legalNSubmitButtonR2RText',
    prePurchaseButtonText: 'legalNSubmitbuttonPrePurchaseText',
    portabilityOTPNeededButtonText: 'legalNSubmitButtonPortabilityOTPNeeded',
    [`${PAYMENT_TYPES.CARD}buttonText`]: 'legalNSubmitCardButtonText',
    [`${PAYMENT_TYPES.FUNDED}buttonText`]: 'legalNSubmitFundedButtonText',
  },
  provisionalAgreement: {
    title: 'provisionalAgreementTitle',
    pdfLinkText: 'provisionalAgreementLinkText',
    postTitle: 'provisionalAgreementPostTitle',
  },
  selectAddress: {
    infoBarData: {
      icon: 'selectAddressInfoBarDataIcon',
      chooseAddress: 'selectAddressInfoBarDataChooseAddress',
    },
    newAddress: 'selectAddressNewAddress',
  },
  ppip: {
    infoBarData: {
      icon: 'ppipInfoBarDataIcon',
      infoText: 'ppipInfoBarDataInfoText',
    },
    checkboxText: 'ppipCheckboxText',
    checkboxSubtitle: 'ppipCheckboxSubtitle',
  },
  deviceSummaryCart: {
    oneTimeChargesText: 'deviceSummaryCartOneTimeChargesText',
    hguWithoutCost: 'deviceSummaryCartHguWithoutCost',
    uhdDecoderWithoutCost: 'deviceSummaryCartUhdDecoderWithoutCost',
    uhdWifiDecoder: 'deviceSummaryCartUhdWifiDecoder',
  },
  oneClickSummary: {
    downgradeMsg: 'oneClickSummaryDowngradeMsg',
    additionalInfo: 'oneClickSummaryAdditionalInfo',
    r2rMsg: 'oneClickSummaryR2rMsg',
  },
  deviceInstallation: {
    infoBarData1: {
      icon: 'ppipInfoBar1DataIcon',
      infoText: 'ppipInfoBar1DataText',
    },
    infoBarData2: {
      icon: 'ppipInfoBar2DataIcon',
      infoText: 'ppipInfoBar2DataInfoText',
    },
    [`${CQ_POTS.INSTALLATION_POT.INSTALLATION_ID}`]: {
      title: 'deviceInstallationInstallationTitle',
      description: 'deviceInstallationInstallationDescription',
      cartText: 'deviceInstallationInstallationCartText',
      additionalInfoText: 'deviceInstallationInstallationAdditionalInfoText'
    },
    [`${CQ_POTS.INSTALLATION_POT.AUTO_INSTALLATION_ID}`]: {
      title: 'deviceInstallationAutoinstallationTitle',
      description: 'deviceInstallationAutoinstallationDescription',
      cartText: 'deviceInstallationAutoinstallationCartText',
      additionalInfoText: 'deviceInstallationAutoinstallationAdditionalInfoText'
    },
    [`${CQ_POTS.INSTALLATION_POT.INSTALLATION_BY_CLIENT}`]: {
      title: 'deviceInstallationInstallationByClientTitle',
      description: 'deviceInstallationInstallationByClientDescription',
      cartText: 'deviceInstallationInstallationByClientCartText',
      additionalInfoText: 'deviceInstallationInstallationByClientAdditionalInfoText'
    },
  },
  obd: {
    modifyContactsInfo: 'obdModifyContactsInfo',
    cancelModify: 'obdCancelModify',
    requestPin: {
      requestedTextMail: 'obdRequestPinRequestedTextMail',
      requestedTextSms: 'obdRequestPinRequestedTextSms',
      pinError: 'obdRequestPinPinError',
      pinExpired: 'obdRequestPinPinExpired',
      validate: 'obdRequestPinValidate',
      newCode: 'obdRequestPinNewCode',
    },
    selectMedium: {
      description: 'obdSelectMediumDescription',
      selectPlaceholder: 'obdSelectMediumSelectPlaceholder',
      sendPin: 'obdSelectMediumSendPin',
    },
    modalTitle: 'obdModalTitle',
    contactsError: {
      image: 'obdContactErrorImage',
      title: 'obdContactErrorTitle',
      paragraph: 'obdContactErrorParagraph',
      secondParagraph: 'obdContactErrorSecondParagraph',
      buttonLink: 'obdContactErrorButtonLink',
      buttonText: 'obdContactErrorButtonText',
    },
    residenceError: {
      image: 'obdResidenceErrorImage',
      title: 'obdResidenceErrorTitle',
      paragraph: 'obdResidenceErrorParagraph',
      secondParagraph: 'obdResidenceErrorSecondParagraph',
      buttonLink: 'obdResidenceErrorButtonLink',
      buttonText: 'obdResidenceErrorButtonText',
    },
    personalDataInfoText: 'obdPersonalDataInfoText',
  },
  scoring: {
    adviceText: 'scoringAdviceText',
    formField: {
      clientName: 'scoringFormFieldClientName',
      contactNumber: 'scoringFormFieldContactNumber',
      birthDate: 'scoringFormFieldBirthDate',
      maritalStatus: 'scoringFormFieldMaritalStatus',
      profession: 'scoringFormFieldProfession',
      incomeType: 'scoringFormFieldIncomeType',
      income: 'scoringFormFieldIncome',
      paymentFrecuency: 'scoringFormFieldPaymentFrecuency',
      seniorityText: 'scoringFormFieldSeniorityText',
      seniorityMonth: 'scoringFormFieldSeniorityMonth',
      seniorityYear: 'scoringFormFieldSeniorityYear',
      checkboxText: 'scoringFormFieldCheckboxText',
      customLinkText: 'scoringFormFieldCustomLinkText',

    },
  },
  chooseNumberOTP: {
    infoBarData: {
      text: 'chooseNumberOTPInfoBarDataText',
      icon: 'chooseNumberOTPInfoBarDataIcon',
    },
    subtitleText: 'chooseNumberOTPSubtitleText',
    reminderText: 'chooseNumberOTPReminderText',
  },
  commitment: {
    subtext: 'commitmentSubtext',
  },
  confirmation: {
    title: 'confirmationTitle',
    subtitle: 'confirmationSubtitle',
    subtitle2: 'confirmationSubtitle2',
    thankYouMsg: 'confirmationThankYouMsg',
    primaryButtonLabel: 'confirmationPrimaryButtonLabel',
    primaryButtonLink: 'confirmationPrimaryButtonLink',
    secondaryButtonLabel: 'confirmationSecondaryButtonLabel',
    secondaryButtonLink: 'confirmationSecondaryButtonLink',
    adviceIcon: 'confirmationSecondaryAdviceIcon',
    advice: 'confirmationSecondaryAdvice',
  },
  deviceConfirmation: {
    title: 'deviceConfirmationTitle',
    text: 'deviceConfirmationText',
    thankYouMsg: 'deviceConfirmationThankYouMsg',
    checkUrl: 'deviceConfirmationCheckUrl',
    crossSelling: {
      subtitle: 'deviceConfirmationCrossSellingSubtitle',
    }
  },
  controlledErrors: {
    incompatibleProducts: 'controlledErrorsIncompatibleProduct',
    defaultClientTypes: 'controlledErrorsDefaultClientTypes',
  },
  waitingPageTexts: {
    initCQ: 'waitingPageTextsInitCQ',
    extendCQ: 'waitingPageTextsExtendCQ',
    selectElements: 'waitingPageTextsSelectElements',
    getFeatures: 'waitingPageTextsGetFeatures',
    addToCart: 'waitingPageTextsAddToCart',
    getPOTs: 'waitingPageTextsGetPOTs',
    getProvisionalAgreement: 'waitingPageTextsGetProvisionalAgreement',
    updateCQ: 'waitingPageTextsUpdateCQ',
    updateCA: 'waitingPageTextsUpdateCA',
    getCQPrices: 'waitingPageTextsGetCQPrices',
    getLegalTerms: 'waitingPageTextsGetLegalTerms',
    confirmCQ: 'waitingPageTextsConfirmCQ',
    getSignatureOTP: 'waitingPageTextsGetSignatureOTP',
    resetFlow: 'waitingPageTextsResetFlow',
    register: 'waitingPageTextsRegister',
    registerNewPin: 'waitingPageTextsRegisterNewPin',
  },
  retargeting: {
    id: 'retargetingId',
  },
  loginCard: {
    text: 'loginCardText',
    label: 'loginCardLabel',
  },
  backToSchool: {
    formTitle: 'backToSchoolFormTitle',
    inputLabel: 'backToSchoolInputLabel',
    SESubject: 'backToSchoolSESubject',
    SEMessage: 'backToSchoolSEMessage',
  }
};

export const localizedStrings = {
  common: {
    everyMainSelection: {
      [STRING_KEYS.waitingPageTexts.initCQ]: 'Recuperando datos personales...',
      [STRING_KEYS.waitingPageTexts.extendCQ]: 'Validando compatibilidad...',
      [STRING_KEYS.waitingPageTexts.selectElements]: 'Validando compatibilidad...',
      [STRING_KEYS.waitingPageTexts.getFeatures]: 'Validando compatibilidad...',
      [STRING_KEYS.waitingPageTexts.addToCart]: 'Validando compatibilidad...',
      [STRING_KEYS.waitingPageTexts.getPOTs]: 'Configurando tu pedido',
      [STRING_KEYS.waitingPageTexts.getProvisionalAgreement]: 'Revisando forma de pago',
      [STRING_KEYS.waitingPageTexts.updateCQ]: 'Revisando forma de pago',
      [STRING_KEYS.waitingPageTexts.updateCA]: '¡Ya estamos acabando! <br />Calculando oferta',
      [STRING_KEYS.waitingPageTexts.getCQPrices]: '¡Ya estamos acabando! <br />Calculando oferta',
      [STRING_KEYS.waitingPageTexts.getLegalTerms]: '¡Ya estamos acabando! <br />Calculando oferta',
      [STRING_KEYS.waitingPageTexts.confirmCQ]: 'Enviando contrato y generando pedido',
      [STRING_KEYS.waitingPageTexts.getSignatureOTP]: 'Generando contrato para la firma',
      [STRING_KEYS.waitingPageTexts.resetFlow]: 'Recuperando datos personales...',
      [STRING_KEYS.waitingPageTexts.register]: 'Validando datos personales...',
      [STRING_KEYS.waitingPageTexts.registerNewPin]: 'Obteniendo nuevo código...',
      [STRING_KEYS.obd.modifyContactsInfo]: 'La modificación y creación de datos de contacto es una operación que por tu seguridad y evitar suplantaciones necesita validación.',
      [STRING_KEYS.obd.cancelModify]: 'Cancelar modificación',
      [STRING_KEYS.obd.requestPin.requestedTextMail]: 'Introduce aquí el código de seguridad que te hemos enviado a tu email {contactValue}',
      [STRING_KEYS.obd.requestPin.requestedTextSms]: 'Introduce aquí el código de seguridad que te hemos enviado por SMS al número {contactValue} para validar esta operación.',
      [STRING_KEYS.obd.requestPin.pinError]: 'El código introducido no es correcto',
      [STRING_KEYS.obd.requestPin.pinExpired]: 'El código ha caducado. Debes solicitar uno nuevo',
      [STRING_KEYS.obd.requestPin.validate]: 'Validar',
      [STRING_KEYS.obd.requestPin.newCode]: 'Recibir nuevo código',
      [STRING_KEYS.obd.selectMedium.description]: 'Elige el medio de contacto donde quieres recibir el código de seguridad para validar el cambio o creación del medio de contacto.',
      [STRING_KEYS.obd.selectMedium.selectPlaceholder]: 'Medio de contacto',
      [STRING_KEYS.obd.selectMedium.sendPin]: 'Recibir código',
      [STRING_KEYS.obd.modalTitle]: 'Datos de contacto',
      [STRING_KEYS.obd.contactsError.image]: 'https://prod.adb.col.movistar.es/content/dam/movistar/estaticos/img/movil-candado.svg',
      [STRING_KEYS.obd.contactsError.title]: 'No dispones de medios de contacto en tu perfil de cliente.',
      [STRING_KEYS.obd.contactsError.paragraph]: 'Para poder realizar un pedido online es necesario que primero completes tus datos de contacto en tu área de cliente.',
      [STRING_KEYS.obd.contactsError.secondParagraph]: 'Sentimos las molestias.',
      [STRING_KEYS.obd.contactsError.buttonLink]: '/area-cliente/mi-perfil/',
      [STRING_KEYS.obd.contactsError.buttonText]: 'Ir a mi perfil',
      [STRING_KEYS.obd.residenceError.image]: 'https://prod.adb.col.movistar.es/content/dam/movistar/estaticos/img/movil-candado.svg',
      [STRING_KEYS.obd.residenceError.title]: 'No dispones de dirección de facturación en tu perfil.',
      [STRING_KEYS.obd.residenceError.paragraph]: 'Para poder realizar un pedido online es necesario que primero completes tus datos llamando gratis al 900 104 430',
      [STRING_KEYS.obd.residenceError.secondParagraph]: 'Sentimos las molestias.',
      [STRING_KEYS.obd.residenceError.buttonLink]: 'tel:900104430',
      [STRING_KEYS.obd.residenceError.buttonText]: 'Llamar gratis al 900 104 430',
      [STRING_KEYS.scoring.adviceText]: 'Para continuar con el pedido necesitamos recoger la siguiente información',
      [STRING_KEYS.scoring.formField.clientName]: 'Nombre y apellidos',
      [STRING_KEYS.scoring.formField.contactNumber]: 'Móvil de contacto',
      [STRING_KEYS.scoring.formField.birthDate]: 'Fecha de Nacimiento',
      [STRING_KEYS.scoring.formField.maritalStatus]: 'Estado civil',
      [STRING_KEYS.scoring.formField.profession]: 'Profesión',
      [STRING_KEYS.scoring.formField.incomeType]: 'Tipo de ingresos',
      [STRING_KEYS.scoring.formField.income]: 'Ingresos mensuales',
      [STRING_KEYS.scoring.formField.paymentFrecuency]: 'Número de pagas',
      [STRING_KEYS.scoring.formField.seniorityText]: 'Indica el mes y año de antigüedad en tu empresa',
      [STRING_KEYS.scoring.formField.seniorityMonth]: 'Mes de antigüedad en la empresa',
      [STRING_KEYS.scoring.formField.seniorityYear]: 'Año de antigüedad en la empresa',
      [STRING_KEYS.scoring.formField.checkboxText]: 'Autorizo ceder mis datos a TCF para realizar el análisis de solvencia y validar la operación.',
      [STRING_KEYS.scoring.formField.customLinkText]: 'Más información.',
      [STRING_KEYS.process.title]: 'Quiero contratar {productOfferingName}',
      [STRING_KEYS.shipment.secondaryText]: '',
      [STRING_KEYS.shipment.text]: 'A domicilio.',
      [STRING_KEYS.shipment.iconId]: ICONS_ID.Envio,
      [STRING_KEYS.shipment.new]: 'Nueva dirección de envío',
      [STRING_KEYS.installation.text]: 'Indica en qué dirección quieres que realicemos la instalación',
      [STRING_KEYS.installation.iconId]: ICONS_ID.Hogar,
      [STRING_KEYS.installation.new]: 'Nueva dirección de instalación',
      [STRING_KEYS.permanentResidence.residence]: 'Indica tu domicilio',
      [STRING_KEYS.permanentResidence.shipmentAsResidence]: 'Esta dirección también se registrará como dirección de facturación',
      [STRING_KEYS.advertisingUse.check]: 'Acepto el uso del email para el envío de información de productos y servicios',
      [STRING_KEYS.payment.step.insertDirectDebit]: 'Indica la cuenta bancaria en la que quieres domiciliar el pago',
      [STRING_KEYS.payment.step.insertDirectDebitSecondaryText]: '',
      [STRING_KEYS.payment.step.chooseDirectDebit]: 'Selecciona la cuenta bancaria en la que quieres domiciliar el pago',
      [STRING_KEYS.payment.step.chooseDirectDebitSecondaryText]: '',
      [STRING_KEYS.payment.step.icon]: 'PagarFacturas',
      [STRING_KEYS.payment.step.inputTitle]: 'Cuenta bancaria (IBAN)',
      [STRING_KEYS.payment.step.newAccText]: 'Nueva cuenta bancaria',
      [STRING_KEYS.summary.title]: 'Confirmación y pago',
      [STRING_KEYS.summary.oneClick.title]: 'Ya casi hemos terminado',
      [STRING_KEYS.summary.oneClick.mainMsg]: 'Una vez finalices el pedido, la nueva configuración estará disponible en unas horas.',
      [STRING_KEYS.summary.personalData.title]: 'Datos de contacto',
      [STRING_KEYS.summary.productBarInfo.text]: '{productOfferingBriefText}',
      [STRING_KEYS.summary.productBarInfo.secondaryText[CQ_ACTION_CODES.REGISTER]]: null,
      [STRING_KEYS.summary.productBarInfo.secondaryText[CQ_ACTION_CODES.PORTABILITY]]: null,
      [STRING_KEYS.summary.productBarInfo.secondaryText[CQ_ACTION_CODES.MIGRATION]]: null,
      [STRING_KEYS.summary.productBarInfo.secondaryText[CQ_ACTION_CODES.KEEP]]: null,
      [STRING_KEYS.summary.productBarInfo.additionalInfoText]: '',
      [STRING_KEYS.summary.nonFiberCoverage.title]: 'No dispones de cobertura de Fibra en esa dirección.',
      [STRING_KEYS.summary.nonFiberCoverage.subtitle]: '',
      [STRING_KEYS.summary.shipment.title]: 'Dirección de envío',
      [STRING_KEYS.summary.shipment.text]: 'Entrega en Madrid y Barcelona: 48h. Península: 72h. Excepto festivos.',
      [STRING_KEYS.summary.shipment.secondaryText]: 'A domicilio',
      [STRING_KEYS.summary.storeShipping.title]: 'Recogida en tienda SIM',
      [STRING_KEYS.summary.storeShipping.text]: 'Podrás recoger tus SIMs en cualquier tienda Movistar.',
      [STRING_KEYS.summary.storeShipping.secondaryText]: 'En caso de portabilidad de línea móvil deberás esperar a recibir el SMS de portabilidad realizada.',
      [STRING_KEYS.summary.storeShipping.adviceText]: null,
      [STRING_KEYS.summary.webAppShipping.title]: '',
      [STRING_KEYS.summary.webAppShipping.text]: '',
      [STRING_KEYS.summary.webAppShipping.secondaryText]: '',
      [STRING_KEYS.summary.installation.title]: 'Dirección de instalación',
      [STRING_KEYS.summary.installation.advice.title]: 'Información adicional:',
      [STRING_KEYS.summary.installation.advice.text[CQ_POTS.INSTALLATION_POT.INSTALLATION_ID]]: '',
      [STRING_KEYS.summary.installation.advice.text[CQ_POTS.INSTALLATION_POT.AUTO_INSTALLATION_ID]]: '',
      [STRING_KEYS.summary.installation.advice.text[CQ_POTS.INSTALLATION_POT.INSTALLATION_BY_CLIENT]]: '',
      [STRING_KEYS.summary.yomvi.title]: 'Activación Movistar+ en tus dispositivos',
      [STRING_KEYS.summary.yomvi.text]: 'Este correo será tu usuario.',
      [STRING_KEYS.summary.yomvi.secondaryText]: 'En un plazo de 24 horas se activará el servicio y recibirás las claves en ese mismo correo.',
      [STRING_KEYS.summary.paymentCard.title]: 'Forma de pago',
      [STRING_KEYS.summary.staticDirectDebit]: 'Misma cuenta donde actualmente se realiza el cobro',
      [STRING_KEYS.summary.nextSteps]: 'Próximos pasos',
      [STRING_KEYS.summary.shoppingCart.title]: '',
      [STRING_KEYS.summary.priceDiscrepancyModal.title]: 'Aviso cambio de precio',
      [STRING_KEYS.summary.priceDiscrepancyModal.content]: 'Tras comprobar tus datos, el precio del dispositivo ha cambiado.',
      [STRING_KEYS.summary.priceDiscrepancyModal.secondaryContent]: 'Puedes revisar el nuevo precio en el resumen del pedido.',
      [STRING_KEYS.summary.priceDiscrepancyModal.viewPriceButton]: 'Entendido',
      [STRING_KEYS.summary.landLineAction.title]: 'Dirección de instalación',
      [STRING_KEYS.summary.landLineAction[CQ_ACTION_CODES.REGISTER]]: 'Número nuevo',
      [STRING_KEYS.summary.landLineAction[CQ_ACTION_CODES.PORTABILITY]]: '{phoneNumber}',
      [STRING_KEYS.summary.landLineAction[CQ_ACTION_CODES.MIGRATION]]: '{phoneNumber}',
      [STRING_KEYS.summary.landLineAction.portabilityWithPPIP]: '{phoneNumber}',
      [STRING_KEYS.summary.landLineAction[CQ_ACTION_CODES.KEEP]]: '{phoneNumber}',
      [STRING_KEYS.summary.landLineAction.icon]: ICONS_ID.Home,
      [STRING_KEYS.summary.landLineAction.label[CQ_ACTION_CODES.REGISTER]]: 'Línea Fija incluida',
      [STRING_KEYS.summary.landLineAction.label[CQ_ACTION_CODES.PORTABILITY]]: 'Portabilidad con verificación',
      [STRING_KEYS.summary.landLineAction.label[CQ_ACTION_CODES.MIGRATION]]: 'Línea Fija incluida',
      [STRING_KEYS.summary.landLineAction.label.portabilityWithPPIP]: 'Portabilidad con instalación inmediata',
      [STRING_KEYS.summary.landLineAction.label[CQ_ACTION_CODES.KEEP]]: 'Línea Fija incluida',
      [STRING_KEYS.summary.landLineAction.subtitle[CQ_ACTION_CODES.PORTABILITY]]: 'Te llamaremos para formalizar la petición de portabilidad.',
      [STRING_KEYS.summary.landLineAction.technologyMigrationText[CQ_ACTION_CODES.MIGRATION]]: '¡Felicidades! Ya hay cobertura de fibra en tu dirección, pasarás a tener Internet sobre fibra',
      [STRING_KEYS.summary.mobileLineAction.title]: 'Línea móvil',
      [STRING_KEYS.summary.mobileLineAction.multipleActionsTitle]: 'Líneas móviles',
      [STRING_KEYS.summary.mobileLineAction[CQ_ACTION_CODES.REGISTER]]: 'Número nuevo',
      [STRING_KEYS.summary.mobileLineAction[CQ_ACTION_CODES.PORTABILITY]]: 'Portabilidad {phoneNumber}',
      [STRING_KEYS.summary.mobileLineAction[CQ_ACTION_CODES.MIGRATION]]: '{phoneNumber}',
      [STRING_KEYS.summary.mobileLineAction[CQ_ACTION_CODES.KEEP]]: '{phoneNumber}',
      [STRING_KEYS.summary.mobileLineAction[CQ_ACTION_CODES.NO_ACTION]]: 'Dar de alta en otro momento',
      [STRING_KEYS.summary.mobileLineAction[CQ_ACTION_CODES.UNSUBSCRIBE]]: '{phoneNumber}',
      [STRING_KEYS.summary.mobileLineAction.icon]: ICONS_ID.Movil,
      [STRING_KEYS.summary.mobileLineAction.alreadyOwnedProductsChoices.title]: 'El resto de tus líneas móviles',
      [STRING_KEYS.summary.mobileLineAction.alreadyOwnedProductsChoices[CQ_ACTION_CODES.UNSUBSCRIBE]]: 'Dar de baja',
      [STRING_KEYS.summary.mobileLineAction.alreadyOwnedProductsChoices[CQ_ACTION_CODES.MIGRATION]]: '{description}',
      [STRING_KEYS.summary.mobileLineAction.index]: 'ª línea móvil',
      [STRING_KEYS.summary.additionalMobileLineAction.title]: 'Líneas móviles adicionales',
      [STRING_KEYS.summary.selectLine.title]: 'Línea móvil asociada',
      [STRING_KEYS.summary.typeOfSim.title]: '¿Que tipo de tarjeta necesitas?',
      [STRING_KEYS.summary.productOfferingToBuyChangedModal.title]: 'Tenemos una oferta mejor para ti',
      [STRING_KEYS.summary.productOfferingToBuyChangedModal.text]: 'Con tu pack miMovistar actual añade',
      [STRING_KEYS.summary.productOfferingToBuyChangedModal.button]: 'Entendido',
      [STRING_KEYS.summary.afterSaleParentProductSelected.title]: '',
      [STRING_KEYS.summary.afterSaleParentProductSelected.phoneNumberLabel]: '',
      [STRING_KEYS.summary.afterSaleParentProductSelected.adviceIcon]: '',
      [STRING_KEYS.summary.afterSaleParentProductSelected.advice]: '',
      [STRING_KEYS.loginCard.label]: 'Identifícate',
      [STRING_KEYS.loginCard.text]: '¿Ya eres cliente?',
      [STRING_KEYS.registerPersonalData.usePassportButtonLabel]: 'Utilizar pasaporte',
      [STRING_KEYS.registerPersonalData.useDNIButtonLabel]: 'Utilizar DNI o NIE',
      [STRING_KEYS.registerPersonalData.inputs.nameLabel]: 'Nombre',
      [STRING_KEYS.registerPersonalData.inputs.firstSurnameLabel]: 'Primer apellido',
      [STRING_KEYS.registerPersonalData.inputs.secondSurnameLabel]: 'Segundo apellido',
      [STRING_KEYS.registerPersonalData.inputs.nationalityLabel]: 'Nacionalidad',
      [STRING_KEYS.registerPersonalData.inputs.documentNumberDNILabel]: 'DNI o NIE',
      [STRING_KEYS.registerPersonalData.inputs.documentNumberPassportLabel]: 'Pasaporte',
      [STRING_KEYS.registerPersonalData.inputs.contactPhoneLabel]: 'Móvil de contacto',
      [STRING_KEYS.registerPersonalData.inputs.contactPhoneLabelDescription]: 'Te enviaremos un SMS para validar tus datos',
      [STRING_KEYS.registerPersonalData.inputs.emailLabel]: 'Email de contacto',
      [STRING_KEYS.registerPersonalData.otpModal.title]: 'Validación de datos de contacto',      
      [STRING_KEYS.registerPersonalData.otpModal.requestedTextSms]: 'Introduce aquí el código de seguridad que te hemos enviado por SMS al número {phoneNumber} para validar tus datos',
      [STRING_KEYS.registerPersonalData.otpModal.pinError]: 'El código introducido no es correcto',
      [STRING_KEYS.registerPersonalData.otpModal.pinExpired]: 'El código introducido ha caducado. Debes solicitar uno nuevo.',
      [STRING_KEYS.registerPersonalData.otpModal.validateButton]: 'Validar',
      [STRING_KEYS.registerPersonalData.otpModal.newCodeButton]: 'Recibir nuevo código',
      [STRING_KEYS.se.risk.subject]: 'TELCOBI - ERROR TELCO RIESGO SERVICIOS NO AT',
      [STRING_KEYS.se.shippingMobileInsurance.subject]: 'TELCOBI - COMPRA SEGURO TERMINAL FUSION',
      [STRING_KEYS.se.message.error.title]: 'Tipo Error',
      [STRING_KEYS.se.message.error.description]: 'Descripción del error',
      [STRING_KEYS.se.message.shipping.type]: 'Tipo envío',
      [STRING_KEYS.se.message.shipping.address]: 'Dirección envío',
      [STRING_KEYS.se.message.shipping[`${CQ_POTS.SHIPPING_POT.HOME_SHIPPING_ID}`]]: 'Envío a domicilio',
      [STRING_KEYS.se.message.shipping[`${CQ_POTS.SHIPPING_POT.STORE_SHIPPING_ID}`]]: 'Envío a tienda',
      [STRING_KEYS.se.message.installation[`${CQ_POTS.INSTALLATION_POT.INSTALLATION_ID}`]]: 'Con instalador',
      [STRING_KEYS.se.message.installation[`${CQ_POTS.INSTALLATION_POT.AUTO_INSTALLATION_ID}`]]: 'Autoinstalable',
      [STRING_KEYS.se.message.installation[`${CQ_POTS.INSTALLATION_POT.INSTALLATION_BY_CLIENT}`]]: 'Instalable por cliente',
      [STRING_KEYS.se.message.payment.account]: 'Cuenta bancaria',
      [STRING_KEYS.se.message.payment.customerAccountId]: 'Id de Cuenta bancaria del cliente',
      [STRING_KEYS.se.message.payment.sameAccount]: 'Misma cuenta actual',
      [STRING_KEYS.se.message.shoppingCart.title]: 'PRODUCTOS ADICIONALES',
      [STRING_KEYS.se.message.shoppingCart[PRODUCT_TYPES.INCLUDED_R2R]]: '',
      [STRING_KEYS.se.message.shoppingCart[PRODUCT_TYPES.ADDITIONAL_R2R]]: '',
      [STRING_KEYS.se.message.shoppingCart[PRODUCT_TYPES.ADDITIONAL_MOBILE]]: '',
      [STRING_KEYS.se.message.shoppingCart[PRODUCT_TYPES.TV]]: '',
      [STRING_KEYS.se.message.shoppingCart[PRODUCT_TYPES.NETFLIX]]: '',
      [STRING_KEYS.se.message.speed.title]: 'Cambio de velocidad',
      [STRING_KEYS.se.message.speed[CHARACTERISTIC_VALUES.SPEED['300MB']]]: '300 Mb',
      [STRING_KEYS.se.message.speed[CHARACTERISTIC_VALUES.SPEED['600MB']]]: '600 Mb',
      [STRING_KEYS.se.message.speed[CHARACTERISTIC_VALUES.SPEED['1GB']]]: '1 Gb',
      [STRING_KEYS.se.message.speed[CHARACTERISTIC_VALUES.SPEED['2GB']]]: '2 Gb',
      [STRING_KEYS.se.message.speed[CHARACTERISTIC_VALUES.SPEED['10GB']]]: '10 Gb',
      [STRING_KEYS.campaignCode]: '',
      [STRING_KEYS.genesys.riskCampaign]: 'ret-genesys-riesgobaf',
      [STRING_KEYS.mainAction[CQ_ACTION_CODES.REGISTER]]: 'Quiero un número nuevo',
      [STRING_KEYS.mainAction[CQ_ACTION_CODES.PORTABILITY]]: 'Traigo un nº de otro operador (portabilidad)',
      [STRING_KEYS.mainAction[CQ_ACTION_CODES.MIGRATION].uniquePhoneNumber]: 'Quiero pasar mi número {phoneNumber} de Movistar a esta tarifa',
      [STRING_KEYS.mainAction[CQ_ACTION_CODES.MIGRATION].multiplePhoneNumbers]: 'Quiero pasar un número de contrato Movistar a esta tarifa',
      [STRING_KEYS.mainAction[CQ_ACTION_CODES.KEEP]]: 'Quiero mantener mi número',
      [STRING_KEYS.mainAction.migrationSelectionTitle]: 'Nº de contrato Movistar',
      [STRING_KEYS.mainAction.infoBar.icon]: ICONS_ID.Movil,
      [STRING_KEYS.mainAction.infoBar.label]: '',
      [STRING_KEYS.mobileSecondaryAction.lmaStepAvice.title]: '',
      [STRING_KEYS.mobileSecondaryAction.lmaStepAvice.steps]: null,
      [STRING_KEYS.mobileSecondaryAction[CQ_ACTION_CODES.REGISTER]]: 'Quiero un número nuevo',
      [STRING_KEYS.mobileSecondaryAction[CQ_ACTION_CODES.PORTABILITY]]: 'Traigo un nº de otro operador (portabilidad)',
      [STRING_KEYS.mobileSecondaryAction[CQ_ACTION_CODES.MIGRATION].uniquePhoneNumber]: 'Quiero pasar mi número {phoneNumber} de Movistar a esta tarifa',
      [STRING_KEYS.mobileSecondaryAction[CQ_ACTION_CODES.MIGRATION].multiplePhoneNumbers]: 'Quiero pasar un número de contrato Movistar a esta tarifa',
      [STRING_KEYS.mobileSecondaryAction[CQ_ACTION_CODES.KEEP]]: 'Quiero mantener mi número',
      [STRING_KEYS.mobileSecondaryAction[CQ_ACTION_CODES.NO_ACTION]]: 'Lo haré más tarde desde mi área privada',
      [STRING_KEYS.mobileSecondaryAction.migrationSelectionTitle]: 'Nº de contrato Movistar',
      [STRING_KEYS.mobileSecondaryAction.migrationNKeepSelectPlaceholder]: 'Número móvil​',
      [STRING_KEYS.mobileSecondaryAction.newLines]: 'Números nuevos',
      [STRING_KEYS.mobileSecondaryAction.oldLines]: 'Números que mantienes',
      [STRING_KEYS.mobileSecondaryAction.infoBar.index]: 'ª línea',
      [STRING_KEYS.mobileSecondaryAction.infoBar.icon]: ICONS_ID.Movil,
      [STRING_KEYS.mobileSecondaryAction.infoBar.label]: '',
      [STRING_KEYS.landLineSecondaryAction[CQ_ACTION_CODES.REGISTER]]: 'Quiero un número nuevo',
      [STRING_KEYS.landLineSecondaryAction[CQ_ACTION_CODES.PORTABILITY]]: 'Traigo un nº de otro operador (portabilidad)',
      [STRING_KEYS.landLineSecondaryAction[CQ_ACTION_CODES.MIGRATION].uniquePhoneNumber]: 'Quiero pasar mi número {phoneNumber} de Movistar a esta tarifa',
      [STRING_KEYS.landLineSecondaryAction[CQ_ACTION_CODES.KEEP]]: 'Quiero mantener mi número {phoneNumber}',
      [STRING_KEYS.landLineSecondaryAction.migrationSelectionTitle]: 'Nº de contrato Movistar',
      [STRING_KEYS.landLineSecondaryAction.infoBar.icon]: ICONS_ID.Home,
      [STRING_KEYS.landLineSecondaryAction.infoBar.label]: '¿Tienes ya un número fijo o necesitas uno nuevo?',
      [STRING_KEYS.landLineSecondaryAction.subTitle]: 'Dirección de instalación',
      [STRING_KEYS.mobilePortability.phoneNumberInputLabel]: 'Nº móvil a portar',
      [STRING_KEYS.mobilePortability.phoneNumberInputDescription]: 'Debes ser el titular de la línea',
      [STRING_KEYS.mobilePortability.smsAdvice]: 'Para verificar el proceso, te enviaremos un código por SMS al móvil que vas a portar, y que tendrás que introducir a continuación.',
      [STRING_KEYS.mobilePortability.prepaidCheckLabel]: 'Este número es de prepago',
      [STRING_KEYS.mobilePortability.getPinButton]: 'Solicitar código',
      [STRING_KEYS.mobilePortability.getNewPinButton]: 'Solicitar nuevo código',
      [STRING_KEYS.mobilePortability.validatePinButton]: 'Validar código',
      [STRING_KEYS.mobilePortability.iccInputPlaceHolder]: 'ICC',
      [STRING_KEYS.mobilePortability.iccHelp]: '¿Dónde puedo encontrarlo?',
      [STRING_KEYS.mobilePortability.iccHelpModalTitle]: '¿Dónde encuentro el ICC?',
      [STRING_KEYS.mobilePortability.iccHelpModalImg]: 'https://prod.adb.col.movistar.es/content/dam/movistar/estaticos/img/tarjeta-movistar-icc.png',
      [STRING_KEYS.mobilePortability.iccHelpModalFirstText]: '1. En el código de barras de la tarjeta que contenía tu SIM',
      [STRING_KEYS.mobilePortability.iccHelpModalSecondText]: '2. Si no tienes disponible la tarjeta, puedes solicitar el ICC a tu operadora actual',
      [STRING_KEYS.mobilePortability.phoneNumberInputRequired]: 'Campo obligatorio',
      [STRING_KEYS.mobilePortability.pinValidationInput]: 'Introduce código',
      [STRING_KEYS.mobilePortability.pinValidationError]: 'El código introducido no es correcto',
      [STRING_KEYS.mobilePortability.pinValidationMaxRetriesError]: 'El código introducido ha caducado. Debes solicitar uno nuevo.',
      [STRING_KEYS.mobilePortability.changePhoneNumber]: 'Modificar número',
      [STRING_KEYS.mobilePortability.componentValidationKO]: 'Debe rellenar todos los datos necesarios para la portabilidad',
      [STRING_KEYS.mobilePortability.errorModalTitle]: 'Aviso',
      [STRING_KEYS.mobilePortability.errorModalButton]: 'Continuar',
      [STRING_KEYS.mobilePortability.validationModal.title]: 'Verificar portabilidad móvil',
      [STRING_KEYS.mobilePortability.validationModal.requestedTextSms]: 'Introduce aquí el código de seguridad que te hemos enviado por SMS al número {phoneNumber}',
      [STRING_KEYS.mobilePortability.validationModal.pinError]: 'El código introducido no es correcto',
      [STRING_KEYS.mobilePortability.validationModal.maxRetriesError]: 'El código introducido ha caducado. Debes solicitar uno nuevo.',
      [STRING_KEYS.mobilePortability.validationModal.validateButton]: 'Validar',
      [STRING_KEYS.mobilePortability.validationModal.newCodeButton]: 'Recibir nuevo código',
      [STRING_KEYS.selectLine.text]: 'Indica el número móvil para el que quieres la multiSIM',
      [STRING_KEYS.selectLine.selectLabel]: 'Línea móvil',
      [STRING_KEYS.multiSimOptions.numberOfSims.text]: '¿Cuántas tarjetas adicionales necesitas?',
      [STRING_KEYS.multiSimOptions.numberOfSims.selectLabel]: 'Número de tarjetas',
      [STRING_KEYS.multiSimOptions.typeOfSims.text]: '',
      [STRING_KEYS.stepTitles.obdError]: '',
      [STRING_KEYS.stepTitles.obdResidenceError]: '',
      [STRING_KEYS.stepTitles.personalData]: 'Revisa tus datos de contacto',
      [STRING_KEYS.stepTitles.productOfferingToBuyChanged[WEBSERVICE_ERRORS.INCOMPATIBLE_PRODUCT_CONTRATO_L]]: 'Podemos ofrecerte esta tarifa a mejor precio',
      [STRING_KEYS.stepTitles.productOfferingToBuyChanged[WEBSERVICE_ERRORS.PRODUCT_WITHOUT_AVAILABLE_ACTIONS]]: 'Lo sentimos, no es posible contratar esta tarifa',
      [STRING_KEYS.stepTitles.mainAction]: 'Indica cómo quieres llevarte este contrato',
      [STRING_KEYS.stepTitles.mobileSecondaryAction]: 'Indica cómo quieres configurar esta tarifa',
      [STRING_KEYS.stepTitles.alreadyOwnedProductsChoices]: '',
      [STRING_KEYS.stepTitles.portabilityOTP]: 'Validación portabilidad',
      [STRING_KEYS.stepTitles.landLineSecondaryAction]: 'Dirección de instalación',
      [STRING_KEYS.stepTitles.ppip]: 'Instalación inmediata',
      [STRING_KEYS.stepTitles.deviceInstallation]: 'Instalación',
      [STRING_KEYS.stepTitles.shipment]: 'Dirección de envío',
      [STRING_KEYS.stepTitles.payment]: 'Indica la forma de pago',
      [STRING_KEYS.stepTitles.scoring]: 'Datos financieros',
      [STRING_KEYS.stepTitles.chooseNumberOTP]: 'Firma del contrato del dispositivo',
      [STRING_KEYS.stepTitles.commitment]: 'Elige cuota mensual del dispositivo',
      [STRING_KEYS.stepTitles.creditLimitError]: '',
      [STRING_KEYS.stepTitles.riskError]: '',
      [STRING_KEYS.stepTitles.debtError]: '',
      [STRING_KEYS.stepTitles.selectParentProduct]: '',
      [STRING_KEYS.stepTitles.numberOfSims]: '',
      [STRING_KEYS.commitment.subtext]: 'Precios con impuestos incluidos.',
      [STRING_KEYS.productOfferingToBuyChanged[WEBSERVICE_ERRORS.INCOMPATIBLE_PRODUCT_CONTRATO_L].text]: 'Por ser cliente te ofrecemos una tarifa de las mismas características a mejor precio.',
      [STRING_KEYS.productOfferingToBuyChanged[WEBSERVICE_ERRORS.INCOMPATIBLE_PRODUCT_CONTRATO_L].secondaryText]: '',
      [STRING_KEYS.productOfferingToBuyChanged[WEBSERVICE_ERRORS.INCOMPATIBLE_PRODUCT_CONTRATO_L].oldProduct]: 'Tarifa seleccionada:',
      [STRING_KEYS.productOfferingToBuyChanged[WEBSERVICE_ERRORS.INCOMPATIBLE_PRODUCT_CONTRATO_L].newProduct]: 'Tarifa recomendada:',
      [STRING_KEYS.productOfferingToBuyChanged[WEBSERVICE_ERRORS.INCOMPATIBLE_PRODUCT_CONTRATO_L].button]: 'Continuar',
      [STRING_KEYS.productOfferingToBuyChanged[WEBSERVICE_ERRORS.INCOMPATIBLE_PRODUCT_CONTRATO_L].linkText]: '',
      [STRING_KEYS.productOfferingToBuyChanged[WEBSERVICE_ERRORS.INCOMPATIBLE_PRODUCT_CONTRATO_L].url]: '',
      [STRING_KEYS.productOfferingToBuyChanged[WEBSERVICE_ERRORS.PRODUCT_WITHOUT_AVAILABLE_ACTIONS].text]: 'La tarifa seleccionada solamente está disponible para clientes que ya disponen de una línea de contrato.',
      [STRING_KEYS.productOfferingToBuyChanged[WEBSERVICE_ERRORS.PRODUCT_WITHOUT_AVAILABLE_ACTIONS].secondaryText]: 'Podemos ofrecerte una tarifa de las mismas características.',
      [STRING_KEYS.productOfferingToBuyChanged[WEBSERVICE_ERRORS.PRODUCT_WITHOUT_AVAILABLE_ACTIONS].oldProduct]: '',
      [STRING_KEYS.productOfferingToBuyChanged[WEBSERVICE_ERRORS.PRODUCT_WITHOUT_AVAILABLE_ACTIONS].newProduct]: 'Tarifa recomendada:',
      [STRING_KEYS.productOfferingToBuyChanged[WEBSERVICE_ERRORS.PRODUCT_WITHOUT_AVAILABLE_ACTIONS].button]: 'Continuar',
      [STRING_KEYS.productOfferingToBuyChanged[WEBSERVICE_ERRORS.PRODUCT_WITHOUT_AVAILABLE_ACTIONS].linkText]: 'Ver otras opciones',
      [STRING_KEYS.productOfferingToBuyChanged[WEBSERVICE_ERRORS.PRODUCT_WITHOUT_AVAILABLE_ACTIONS].url]: URLS.MOBILE_TARIFF_LIST,
      [STRING_KEYS.risk.title]: 'No es posible generar tu pedido automáticamente',
      [STRING_KEYS.risk.firstParagraph]: 'Para intentar solucionarlo podemos notificarlo al departamento correspondiente que se pondrá en contacto contigo.',
      [STRING_KEYS.risk.secondParagraph]: 'Solo se enviará la siguiente información:',
      [STRING_KEYS.risk.personalData]: 'Nombre, documento identificativo, móvil y mail de contacto',
      [STRING_KEYS.risk.button]: 'Enviar información',
      [STRING_KEYS.risk.secondaryButton]: 'Cancelar',
      [STRING_KEYS.risk.modal.buttonLink]: 'https://app.movistar.es',
      [STRING_KEYS.risk.modal.buttonText]: 'Volver a movistar.es',
      [STRING_KEYS.risk.modal.title]: 'Información enviada correctamente',
      [STRING_KEYS.risk.modal.paragraph]: 'En breve nos pondremos en contacto contigo para darte una solución.',
      [STRING_KEYS.se.order.subject]: 'TELCOBI - ERROR COL TELCO',
      [STRING_KEYS.clientRegister.url]: '/order/telco/registro',
      [STRING_KEYS.shoppingCart.haveMaintainingPromo]: '* Mantenemos tu promoción actual compatible con este cambio.',
      [STRING_KEYS.shoppingCart.taxesBand]: 'Precios con impuestos incluidos',
      [STRING_KEYS.shoppingCart.specificTaxesBand]: 'Precios con {taxName} incluido.',
      [STRING_KEYS.shoppingCart.title]: 'Resumen del pedido',
      [STRING_KEYS.shoppingCart.prePurchaseTitle]: 'Resumen del pedido',
      [STRING_KEYS.shoppingCart.downgradeAdviceTitle]: 'Información adicional:',
      [STRING_KEYS.shoppingCart.downgradeAdviceText]: 'Esta contratación implica la baja de {productName}',
      [STRING_KEYS.shoppingCart.characteristic[CHARACTERISTICS.NETFLIX][CHARACTERISTIC_VALUES.NETFLIX.STANDARD]]: 'Netflix estándar',
      [STRING_KEYS.shoppingCart.characteristic[CHARACTERISTICS.NETFLIX][CHARACTERISTIC_VALUES.NETFLIX.STANDARD_ADS]]: 'Netflix estándar con anuncios',
      [STRING_KEYS.shoppingCart.characteristic[CHARACTERISTICS.NETFLIX][CHARACTERISTIC_VALUES.NETFLIX.PREMIUM]]: 'Netflix premium',
      [STRING_KEYS.legalNSubmit.titleModal]: 'Condiciones legales',
      [STRING_KEYS.legalNSubmit.buttonText]: 'Confirmar compra',
      [STRING_KEYS.legalNSubmit.buttonR2RText]: 'Ver y firmar contrato',
      [STRING_KEYS.legalNSubmit.prePurchaseButtonText]: 'Precompra',
      [STRING_KEYS.legalNSubmit.portabilityOTPNeededButtonText]: 'Validación portabilidad',
      [STRING_KEYS.legalNSubmit[`${PAYMENT_TYPES.CARD}buttonText`]]: 'Pagar con tarjeta',
      [STRING_KEYS.legalNSubmit[`${PAYMENT_TYPES.FUNDED}buttonText`]]: 'Ir a financiación',
      [STRING_KEYS.legalNSubmit.legalCheckout.linkableText]: 'condiciones generales, particulares y de desistimiento.',
      [STRING_KEYS.legalNSubmit.legalCheckout.nonLinkableText]: 'He leído y acepto las ',
      [STRING_KEYS.selectParentProduct.label]: 'Línea: {productValue}',
      [STRING_KEYS.selectParentProduct.subtitle]: '',
      [STRING_KEYS.provisionalAgreement.title]: 'Te hemos enviado por email las condiciones del contrato, también puedes ',
      [STRING_KEYS.provisionalAgreement.pdfLinkText]: 'descargarlas aquí en PDF.',
      [STRING_KEYS.provisionalAgreement.postTitle]: '',
      [STRING_KEYS.ppip.infoBarData.icon]: ICONS_ID.Home,
      [STRING_KEYS.ppip.infoBarData.infoText]: 'Con instalación inmediata, tendrá rápidamente Internet en casa con una línea provisional mientras portamos la suya.',
      [STRING_KEYS.ppip.checkboxText]: 'Quiere instalación inmediata ...',
      [STRING_KEYS.ppip.checkboxSubtitle]: '…. y acepta tener Internet de Movistar de forma inmediata con una línea provisional. Si solicita la baja de esta línea, abonará, por los desplazamientos y trabajos de instalación de la misma , un máximo de 130€ (impuestos no incluidos).',
      [STRING_KEYS.deviceInstallation.infoBarData1.icon]: ICONS_ID.Router,
      [STRING_KEYS.deviceInstallation.infoBarData1.infoText]: 'Necesitas nuevo equipamiento para el servicio contratado.',
      [STRING_KEYS.deviceInstallation.infoBarData2.icon]: ICONS_ID.Ajustes,
      [STRING_KEYS.deviceInstallation.infoBarData2.infoText]: 'Elige tipo de instalación.',
      [STRING_KEYS.deviceInstallation[CQ_POTS.INSTALLATION_POT.INSTALLATION_ID].title]: 'Con instalación de un técnico',
      [STRING_KEYS.deviceInstallation[CQ_POTS.INSTALLATION_POT.INSTALLATION_ID].description]: 'Te llamaremos para concertar cita para la instalación.',
      [STRING_KEYS.deviceInstallation[CQ_POTS.INSTALLATION_POT.INSTALLATION_ID].additionalInfoText]: 'Con instalación de un técnico',
      [STRING_KEYS.deviceInstallation[CQ_POTS.INSTALLATION_POT.AUTO_INSTALLATION_ID].title]: 'Autoinstalación',
      [STRING_KEYS.deviceInstallation[CQ_POTS.INSTALLATION_POT.AUTO_INSTALLATION_ID].description]: 'Envío a domicilio en 48 horas, con unas sencillas instrucciones y teléfono de ayuda.',
      [STRING_KEYS.deviceInstallation[CQ_POTS.INSTALLATION_POT.AUTO_INSTALLATION_ID].additionalInfoText]: 'Autoinstalación: entrega en 48/72h',
      [STRING_KEYS.deviceInstallation[CQ_POTS.INSTALLATION_POT.INSTALLATION_BY_CLIENT].title]: 'Autoinstalación',
      [STRING_KEYS.deviceInstallation[CQ_POTS.INSTALLATION_POT.INSTALLATION_BY_CLIENT].description]: 'Envío a domicilio en 48 horas, con unas sencillas instrucciones y teléfono de ayuda.',
      [STRING_KEYS.deviceInstallation[CQ_POTS.INSTALLATION_POT.INSTALLATION_BY_CLIENT].additionalInfoText]: 'Autoinstalación: entrega en 48/72h',
      [STRING_KEYS.deviceSummaryCart.oneTimeChargesText]: 'Envío dispositivo',
      [STRING_KEYS.oneClickSummary.downgradeMsg]: '· el cambio de configuración que estás realizando es incompatible con tu paquete actual {downgrade} por lo que lo daremos de baja.',
      [STRING_KEYS.oneClickSummary.r2rMsg]: '· la cuota de tu dispositivo {name} cambia a {price} €/mes',
      [STRING_KEYS.oneClickSummary.additionalInfo]: 'Información adicional:',
      [STRING_KEYS.summary.mobileInsurance.title]: 'Añade seguro. ¡No te la juegues!',
      [STRING_KEYS.summary.mobileInsurance.infoBar]: 'Elige la cobertura que más se adapte a ti.',
      [STRING_KEYS.summary.mobileInsurance.claimText]: 'En las próximas horas recibirás un mail con toda la información relativa a tu póliza de seguro.',
      [STRING_KEYS.chooseNumberOTP.infoBarData.text]: 'Te enviaremos un SMS al siguiente número para realizar la firma del contrato del dispositivo.',
      [STRING_KEYS.chooseNumberOTP.infoBarData.icon]: ICONS_ID.Documento,
      [STRING_KEYS.chooseNumberOTP.subtitleText]: 'Elige el número móvil dónde recibir el SMS',
      [STRING_KEYS.chooseNumberOTP.reminderText]: 'Necesitarás tener a mano el móvil',
      [STRING_KEYS.summary.manualSummaryAdvice.text]: '',
      [STRING_KEYS.summary.manualSummaryAdvice.link]: '',
      [STRING_KEYS.summary.manualSummaryAdvice.linkText]: '',
      [STRING_KEYS.summary.cart.manualOneTimeChargesTitle]: '',
      [STRING_KEYS.summary.cart.manualOneTimeChargesFinalPriceText]: '',
      [STRING_KEYS.summary.cart.manualRecurringChargesFinalPriceText]: '',
      [STRING_KEYS.summary.cart.manualRecurringChargesFinalPriceTextBelow]: '',
      [STRING_KEYS.summary.cart.manualOneTimeChargesFinalPriceTextBelow]: '',
      [STRING_KEYS.summary.cart.oneTimeChargesTitle[CQ_POTS.PAYMENT_POT.DIRECT_DEBIT_ID]]: 'Pago único en primera factura',
      [STRING_KEYS.summary.cart.oneTimeChargesFinalPriceText[CQ_POTS.PAYMENT_POT.DIRECT_DEBIT_ID]]: 'Pago único',
      [STRING_KEYS.summary.cart.mobileInsuranceTitle]: 'Otros conceptos',
      [STRING_KEYS.summary.cart.recurringChargesFinalPriceText[CQ_POTS.PAYMENT_POT.DIRECT_DEBIT_ID]]: 'Cuota mensual',
      [STRING_KEYS.summary.cart.recurringChargesFinalPriceTextBelow[CQ_POTS.PAYMENT_POT.DIRECT_DEBIT_ID]]: `Cuota sin promociones {groupPriceBeforeDiscounts}${SHOPPING_CART_CONSTANTS.RECURRING_CHARGES_UNITY}`,
      [STRING_KEYS.summary.cart.oneTimeChargesFinalPriceTextBelow[CQ_POTS.PAYMENT_POT.DIRECT_DEBIT_ID]]: '',
      [STRING_KEYS.summary.cart.oneTimeChargesFinalPriceTextBelow[CQ_POTS.PAYMENT_POT.FUNDED]]: `{months} cuotas. Total adeudado: {totalAmountToPay}${SHOPPING_CART_CONSTANTS.ONE_TIME_CHARGES_UNITY}`,
      [STRING_KEYS.summary.cart.oneTimeChargesFinalPriceTextBelow[CQ_POTS.PAYMENT_POT.FUNDED_NO_TAXES]]: `{months} cuotas. Total adeudado: {totalAmountToPay}${SHOPPING_CART_CONSTANTS.ONE_TIME_CHARGES_UNITY}`,
      [STRING_KEYS.summary.cart.oneTimeChargesFinalPriceTextBelow[CQ_POTS.PAYMENT_POT.FUNDED_SPECIAL_TAXES]]: `{months} cuotas. Total adeudado: {totalAmountToPay}${SHOPPING_CART_CONSTANTS.ONE_TIME_CHARGES_UNITY}`,
      [STRING_KEYS.confirmation.title]: 'Pedido realizado con éxito',
      [STRING_KEYS.confirmation.subtitle]: 'Te enviaremos un email con la confirmación de tu pedido.',
      [STRING_KEYS.confirmation.subtitle2]: '',
      [STRING_KEYS.confirmation.thankYouMsg]: 'Muchas gracias por confiar en Movistar.',
      [STRING_KEYS.confirmation.primaryButtonLabel]: '',
      [STRING_KEYS.confirmation.primaryButtonLink]: '',
      [STRING_KEYS.confirmation.secondaryButtonLabel]: '',
      [STRING_KEYS.confirmation.secondaryButtonLink]: '',
      [STRING_KEYS.confirmation.adviceIcon]: '',
      [STRING_KEYS.confirmation.advice]: '',
      [STRING_KEYS.deviceConfirmation.title]: 'Pedido realizado con éxito',
      [STRING_KEYS.deviceConfirmation.text]: 'Te enviaremos un email con la confirmación de tu pedido. Gracias por confiar en Movistar',
      [STRING_KEYS.deviceConfirmation.thankYouMsg]: '¡Gracias!',
      [STRING_KEYS.deviceConfirmation.checkUrl]: 'https://prod.adb.col.movistar.es/content/dam/movistar/estaticos/img/proceso_completado.gif',
      [STRING_KEYS.deviceConfirmation.crossSelling.subtitle]: 'No disponible en Canarias, Ceuta y Melilla',
      [STRING_KEYS.controlledErrors.incompatibleProduct]: null,
      [STRING_KEYS.controlledErrors.defaultClientType]: null,
      [STRING_KEYS.selectAddress.infoBarData.icon]: ICONS_ID.Home,
      [STRING_KEYS.selectAddress.infoBarData.chooseAddress]: 'Indica la dirección donde instalar el producto',
      [STRING_KEYS.selectAddress.newAddress]: 'Nueva dirección de instalación',
      [STRING_KEYS.stepTitles.installation]: 'Dirección de instalación',
      [STRING_KEYS.stepTitles.newInstallationAddress]: 'Dirección de instalación',
      [STRING_KEYS.backToSchool.formTitle]: 'Email centro educativo',
      [STRING_KEYS.backToSchool.inputLabel]: 'Email de estudiante o docente',
      [STRING_KEYS.backToSchool.SEMessage]: 'Email de estudiante o docente: ',
      [STRING_KEYS.backToSchool.SESubject]: 'Promo Estudiantes Apple',
    },
    [`mainSelection_${CQ_ACTION_CODES.REGISTER}`]: {},
    [`mainSelection_${CQ_ACTION_CODES.PORTABILITY}`]: {},
    [`mainSelection_${CQ_ACTION_CODES.MIGRATION}`]: {
      [STRING_KEYS.process.title]: 'Quiero cambiarme a {productOfferingName}',
    },
    [`mainSelection_${CQ_ACTION_CODES.ACTIVATE_LINE}`]: {},
    [`mainSelection_${CQ_ACTION_CODES.UPGRADE_INCLUDED_LINE}`]: {},
  },
  [`user_${USER_TYPE.TELCO}`]: {
    everyMainSelection: {
    },
    [`mainSelection_${CQ_ACTION_CODES.REGISTER}`]: {},
    [`mainSelection_${CQ_ACTION_CODES.PORTABILITY}`]: {},
    [`mainSelection_${CQ_ACTION_CODES.MIGRATION}`]: {},
    [`mainSelection_${CQ_ACTION_CODES.ACTIVATE_LINE}`]: {},
    [`mainSelection_${CQ_ACTION_CODES.UPGRADE_INCLUDED_LINE}`]: {},
  },
  [`user_${USER_TYPE.OPEN}`]: {
    everyMainSelection: {
      [STRING_KEYS.stepTitles.permanentResidence]: 'Domicilio de facturación',
    },
    [`mainSelection_${CQ_ACTION_CODES.REGISTER}`]: {},
    [`mainSelection_${CQ_ACTION_CODES.PORTABILITY}`]: {},
    [`mainSelection_${CQ_ACTION_CODES.MIGRATION}`]: {},
    [`mainSelection_${CQ_ACTION_CODES.ACTIVATE_LINE}`]: {},
    [`mainSelection_${CQ_ACTION_CODES.UPGRADE_INCLUDED_LINE}`]: {},
  },
  selfEmployed: {
    everyMainSelection: {
    },
  },
};
